export const setTenantLoggedIn = ()=>{
    localStorage.setItem("tenantLoggedIn", "true");
    setLandlordLoggedOut();
}
export const setTenantLoggedOut = ()=>{
    localStorage.removeItem("tenantLoggedIn");
}
export const setLandlordLoggedIn = ()=>{
    localStorage.setItem("landlordLoggedIn", "true");
    setTenantLoggedOut();
}
export const setLandlordLoggedOut = ()=>{
    localStorage.removeItem("landlordLoggedIn");
}

export const isTenantLoggedIn = ()=>{
    let tenantOnlyLoggedIn = localStorage.getItem("tenantLoggedIn") && !localStorage.getItem("landlordLoggedIn");
    return tenantOnlyLoggedIn;
}

export const isLandlordLoggedIn = ()=>{
    let landlordOnlyLoggedIn = localStorage.getItem("landlordLoggedIn") && !localStorage.getItem("tenantLoggedIn");
    return landlordOnlyLoggedIn;
}

export const flushLoggedInUser = ()=>{
    localStorage.removeItem('token');
    setTenantLoggedOut();
    setLandlordLoggedOut();
}